import JobTypeSearch from './JobTypeSearch.container';

export default JobTypeSearch;
